/**
 * @file:
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/8/7      1.0     Second version
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent,Fragment} from "react";
import {Spin,message,Pagination,Empty} from 'antd';
// import FollowUpDrawer from "@components/FollowUp/FollowUpDrawer"
import Lang from "@/components/Lang/Lang";
import {getWeek,getIntlYYMMDD} from "@utils/utils";
import FollowUpAction from "../FollowUp.action"
import "./followHistoryList.less";

export default class FollowHistoryList extends PureComponent {
    static defaultProps = {
        showAdd: true, // 显示
        labelType:'',
        buyerInternalId:null
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            total:0,
            pageSize:50,
        }
    }

    renderOne(item,inx){
        return (<div className={"followUpHistoryBox"} key={"followUpH_"+inx}>
            <div className={"flex-item-between"}>
                <span>
                    {item.createTime?getIntlYYMMDD(item.createTime,"HH:mm:ss"):""}
                </span>
                <span className={"black66"}><i className={"ri-user-line font_18 mr_4"} />{item.createByName}</span>
            </div>
            <div className={"mt_8 black66"}>{item.email||"-"}</div>
            <div className={"mt_8"}>{item.followRemark||"-"}</div>
            <div className={"mt_8 black66 fw_700 rowFile flex-item"}>
                <span>{Lang({id:"FuJian",default:"附件"})}：</span>
                {item.fileList&&item.fileList.length>0?<Fragment>
                        {item.fileList.map((file,inx)=>{
                            return(<a className={"linkFile ellipsis mb_4"} key={inx} href={file.url} target={"_blank"} title={file.niceRealNameWithExtend}>
                                {file.niceRealNameWithExtend}
                            </a>)
                        })}
                </Fragment>:<span className={"black45"}>{Lang({id:"Wu",default:"无"})}</span>}
            </div>
            <div className={"mt_4 yellowBox"}>
                <div className={"fw_500"}>{Lang({id:"XiaCiGenJin",default:"下次跟进"})}：{item.nextFollowTime?<span>
                                {getIntlYYMMDD(item.nextFollowTime)}
                                <span className={"ml_4"}>{getWeek(item.nextFollowTime)}</span>
                            </span>:"-"}
                </div>
                {item.nextFollowRemark?<div className={"mt_4 black66"}>{item.nextFollowRemark}</div>:null}
                <div className={"mt_4 black66 rowFile flex-item"}>
                    <span className={"mt_4"}>{Lang({id:"FuJian",default:"附件"})}：</span>
                    {item.nextFollowFileList&&item.nextFollowFileList.length>0?<Fragment>
                        {item.nextFollowFileList.map((file,inx)=>{
                            // const fileName = file.url.substr(file.url.lastIndexOf("/")+1);
                            return(<a className={"linkFile ellipsis mt_4"} key={inx} href={file.url} target={"_blank"} title={file.niceRealNameWithExtend}>
                                {file.niceRealNameWithExtend}
                            </a>)
                        })}
                    </Fragment>:<span className={"black45 mt_4"}>{Lang({id:"Wu",default:"无"})}</span>}
                </div>
            </div>
        </div>)
    }
    /**
     * 列表
     **/
    getList(pageIndex=1,){
        const {buyerId,buyerInternalId} = this.props;
        if(buyerId||buyerInternalId){
            const {pageSize} = this.state;
            this.loading(true);
            let postData = {
                pagingQuery:{
                    pageIndex:pageIndex,
                    pageSize:pageSize
                }
            };
            if(buyerInternalId){
                postData.buyerInternalId = buyerInternalId;
            }else{
                postData.buyerId = buyerId;
            }

            FollowUpAction.postHttpAction("/service/mg/follower/follow/history-list",postData).then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));
        }
    }
    handleRes(res={}){
        const {success,valid,models,paging={}} = res;
        if (success && valid) {
            this.setState({
                list: models,
                total:paging.total||0
            })
        }else {
            if(res.message)message.error(res.message);
        }
        this.loading(false);
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    openDrawer(flag){
        // this.setState({
        //     visibleFollowUpDrawer:flag
        // })
        if(flag){
            if (this.childRefDrawer) {
                this.childRefDrawer.getCustomer()
            }
            if(this.props.openDrawerCallBack){
                this.props.openDrawerCallBack()
            }
        }
    }
    // childRef = (ref) =>  this.childRefDrawer = ref;
    componentWillMount() {
        this.getList()
    }
    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
    }
    render() {
        const {buyerId, showAdd=true} = this.props;
        const {loading = true,total=0,pageSize,list=[],visibleFollowUpDrawer} = this.state;
        return (<Spin spinning={loading}>
            <div className="black89 font-14">
                <div className={"fw_500 font_18 flex-item-ver-center"}>{Lang({id:"GenJinJiLu",default:"跟进记录"})}
                {showAdd&&<i onClick={()=>this.openDrawer(true)}
                             className={"ri-add-circle-line ml_8 color-blue3 font_24 fw_400 cursor-p"} />}
                </div>
                {list&&list.length>0?<Fragment>
                    {list.map((item,inx)=>this.renderOne(item,inx))}
                    {total>pageSize?<Pagination className={"mt_12"} defaultCurrent={1} total={total} pageSize={pageSize} onChange={(page)=>this.getList(page)} />:null}
                </Fragment>:<Empty description={Lang({id: "ZanWuShuJu", default: "暂无数据"})} className="mt_16 mb_16 followUpHistoryBox"></Empty>}
            </div>
            {/*<FollowUpDrawer buyerId={buyerId}*/}
                            {/*onRef={this.childRef}*/}
                            {/*visibleFollowUpDrawer={visibleFollowUpDrawer}*/}
                            {/*showDrawer={(flag)=>this.openDrawer(flag)} />*/}
        </Spin>);
    }
}
